export default __webpack_public_path__ + "static/media/backgroundCard.85cb8ad5.png";